import { types } from './actions';

const initialState = {
  customInterrogations: [],
  isCreating: false,
  isModalOpen: false,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.INIT:
      return {
        ...state,
        customInterrogations: payload.customInterrogations,
      };
    case types.CREATE_MODAL_OPEN:
      return {
        ...state,
        isModalOpen: true,
      };
    case types.CREATE_MODAL_CLOSE:
      return {
        ...state,
        isModalOpen: false,
      };
    case types.CREATE_CUSTOM_INTERROGATION_REQUEST:
      return {
        ...state,
        isCreating: true,
      };
    case types.CREATE_CUSTOM_INTERROGATION_SUCCESS:
      return {
        ...state,
        customInterrogations: state.customInterrogations.concat([
          payload.customInterrogation,
        ]),
        isCreating: false,
      };
    case types.CREATE_CUSTOM_INTERROGATION_ERROR:
      return {
        ...state,
        isCreating: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.customInterrogations.listPage;

export const getCustomInterrogations = (state) =>
  getScope(state).customInterrogations;

export const getIsCreating = (state) => getScope(state).isCreating;

export const getIsModalOpen = (state) => getScope(state).isModalOpen;
